export default __webpack_public_path__ + "static/media/img_vision_04_m.6fa63c6a.png";